import { useMutation } from "react-query";
import http from "infra/http";

export default function useImportRetornoBancario() {
  return useMutation(
    (files: File[]) => {
      const form = new FormData();

      for (const file of files) {
        form.append("files", file);
      }

      return http.post(`/v1/retorno-bancario`, form);
    },
    { retry: false }
  );
}
